var _circle, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElfoIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.5,
    fill: "#E9E9E9",
    stroke: "url(#paint0_linear_71_4951)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0824 15.9018C15.6183 15.9018 12 19.5201 12 23.9842C12 28.4483 15.6183 32.0666 20.0824 32.0666C24.5465 32.0666 28.1648 28.4483 28.1648 23.9842C28.2118 19.5201 24.5465 15.9018 20.0824 15.9018ZM20.0824 27.9784C17.8738 27.9784 16.0882 26.1927 16.0882 23.9842C16.0882 21.7756 17.8738 19.99 20.0824 19.99C22.2909 19.99 24.0766 21.7756 24.0766 23.9842C24.0766 26.1927 22.2909 27.9784 20.0824 27.9784Z",
    fill: "#143A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4171 14.6801C17.7667 14.6801 18.8607 13.5861 18.8607 12.2365C18.8607 10.887 17.7667 9.79303 16.4171 9.79303C15.0676 9.79303 13.9736 10.887 13.9736 12.2365C13.9736 13.5861 15.0676 14.6801 16.4171 14.6801Z",
    fill: "#0BA9E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7612 14.1632C22.7612 14.1632 28.3531 13.5993 28.1651 6.97361C28.1651 6.97361 21.9623 6.12778 20.5996 12.1896C20.5996 12.1896 22.2443 10.4979 23.9359 10.8738C23.9829 10.8738 24.4998 12.8005 22.7612 14.1632Z",
    fill: "#38C669"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_4951",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D57A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA858",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElfoIconNew);
export default __webpack_public_path__ + "static/media/elfo_icon_new.d0487b7fa5ee9000e6de6b7d9c207fda.svg";
export { ForwardRef as ReactComponent };